import { divUsdt, formatCompactNumber, formatUsdt, gteUsdt, type MoneyInput } from '@/utils/money';

export type EnergyPresetUnit = 'tenThousand' | 'thousand' | 'million' | 'none';

export type EnergyPresetScale = {
  value: string;
  unit: EnergyPresetUnit;
};

function usesTenThousandScale(locale?: string): boolean {
  const lang = (locale || 'en').toLowerCase();
  return lang.startsWith('zh') || lang.startsWith('ja') || lang.startsWith('ko');
}

/**
 * Scale an energy preset for compact capsule labels.
 * zh / ja / ko use 10,000; other locales use thousand / million.
 */
export function scaleEnergyPreset(amount: MoneyInput, locale?: string): EnergyPresetScale {
  if (usesTenThousandScale(locale) && gteUsdt(amount, 10000)) {
    return {
      value: formatUsdt(divUsdt(amount, 10000), { maxDecimals: 2, zeroDisplay: '0' }),
      unit: 'tenThousand',
    };
  }

  if (gteUsdt(amount, 1000000)) {
    return {
      value: formatUsdt(divUsdt(amount, 1000000), { maxDecimals: 2, zeroDisplay: '0' }),
      unit: 'million',
    };
  }

  if (gteUsdt(amount, 1000)) {
    return {
      value: formatUsdt(divUsdt(amount, 1000), { maxDecimals: 2, zeroDisplay: '0' }),
      unit: 'thousand',
    };
  }

  return {
    value: formatCompactNumber(amount),
    unit: 'none',
  };
}
